import React from 'react'
import { Text, View } from 'styles/reactnative'
import PopUpDelete from './PopUpDelete'
import { removeHTML, truncateText } from 'utils/ExpensiveFunction'
import PopUpUpdate from './PopUpUpdate'
import moment from 'moment'
import { Switch } from 'antd'
import SettingGroup from '../SettingGroup'

export const AdminPopUpColumns = openModal => {
	return [
		{
			title: 'NO',
			dataIndex: 'id',
			render: (text, data) => (
				<Text style={{ justifyContent: 'flex-start' }}>{data?.id}</Text>
			),
		},
		{
			title: '제목',
			dataIndex: 'title',
			width: 300,
			render: (text, data) => (
				<Text style={{ justifyContent: 'flex-start' }}>
					{data?.title ? truncateText(data?.title, 100) : '-'}
				</Text>
			),
		},
		{
			title: '그룹',
			dataIndex: 'target',
			width: 200,
			render: (text, data) => (
				<SettingGroup
					group={data?.target}
					setGroup={e => {
						console.log(e)
					}}/>
			),
		},
		{
			title: '내용',
			dataIndex: 'content',
			width: 300,
			render: (text, data) => (
				<Text style={{ justifyContent: 'flex-start' }}>
					{data?.content ? truncateText(removeHTML(data?.content), 50) : '-'}
				</Text>
			),
		},
		{
			title: '생성일시',
			dataIndex: 'startdate',
			width: 250,
			render: (text, data) => (
				<Text style={{ justifyContent: 'flex-start' }}>
					{data?.startdate
						? moment(data?.startdate).format('YYYY-MM-DD')
						: '-'}
				</Text>
			),
		},
		{
			title: '종료일시',
			dataIndex: 'enddate',
			width: 250,
			render: (text, data) => (
				<Text style={{ justifyContent: 'flex-start' }}>
					{data?.enddate
						? moment(data?.enddate).format('YYYY-MM-DD')
						: '-'}
				</Text>
			),
		},
		{
			title: '사이즈 가로',
			dataIndex: 'width',
			width: 200,
			render: (text, data) => (
				<Text style={{ justifyContent: 'flex-start' }}>
					{data?.width ? data?.width : '-'}
				</Text>
			),
		},
		{
			title: '사이즈 세로',
			dataIndex: 'height',
			width: 200,
			render: (text, data) => (
				<Text style={{ justifyContent: 'flex-start' }}>
					{data?.height ? data?.height : '-'}
				</Text>
			),
		},
		{
			title: 'x 위치',
			dataIndex: 'x',
			width: 200,
			render: (text, data) => (
				<Text style={{ justifyContent: 'flex-start' }}>
					{data?.x ? data?.x : '-'}
				</Text>
			),
		},
		{
			title: 'y 위치',
			dataIndex: 'y',
			width: 200,
			render: (text, data) => (
				<Text style={{ justifyContent: 'flex-start' }}>
					{data?.y ? data?.y : '-'}
				</Text>
			),
		},
		{
			title: '활성화',
			dataIndex: 'active',
			width: 200,
			render: (text, data) => (
				<Switch checked={data?.active} disabled={true} />
			),
		},
		{
			title: '모바일',
			dataIndex: 'mobile',
			width: 200,
			render: (text, data) => (
				<Switch checked={data?.mobile} disabled={true} />
			),
		},
		{
			title: '관리',
			dataIndex: 'manage',
			width: 200,
			render: (text, data) => (
				<View
					style={{
						flexDirection: 'row',
						width: 110,
						justifyContent: 'space-between',
					}}>
					<PopUpDelete data={data} />
					<PopUpUpdate data={data} />
				</View>
			),
		},
	]
}
